module.exports = __webpack_public_path__ + "static/ec-os-mobile-chart-2b82609043898a8fff9721b81306a56d.png";